export const getMergedComponentStyles = (
  aggregateStyles: Record<string, { components: Record<string, unknown> }>,
) => {
  let allComponentsSubkeys: string[] = []
  const aggregateStyleKeys = Object.keys(aggregateStyles)
  aggregateStyleKeys.forEach((key) => {
    const childKeys = Object.keys(aggregateStyles[key].components)
    allComponentsSubkeys = [...allComponentsSubkeys, ...childKeys]
  })

  //check for dupes
  const uniques = new Set(allComponentsSubkeys)
  const hasDupes = allComponentsSubkeys.length != uniques.size

  if (hasDupes) {
    //log the duplicates to the console as a loud error
    const uniquesArray = Array.from(uniques)
    const dupes = uniquesArray.filter((item) => {
      const dupeCount = allComponentsSubkeys.filter((k) => k === item).length

      return dupeCount > 1
    })

    //we know that duplicates exist
    const dotWalkedConflicts = aggregateStyleKeys
      .map((key) => {
        const dupedKeys: string[] = []
        dupes.forEach((dupe) => {
          if (aggregateStyles[key].components[dupe]) {
            dupedKeys.push(`${key}.${dupe}`)
          }
        })
        return dupedKeys
      })
      .flat()

    //report error on dot-walked-conflicts
    if (dotWalkedConflicts.length > 0) {
      const errorMessage = `Duplicate component styles found: \n${dotWalkedConflicts.join(
        '\n',
      )}`
      console.error(errorMessage)
      throw new Error(errorMessage)
    }
  }

  let merged = {}
  aggregateStyleKeys.forEach((key) => {
    merged = { ...merged, ...aggregateStyles[key].components }
  })

  return merged
}
